import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/use-auth'
import { useJobMatchingStatus } from '@/hooks/use-job-matching-status'
import { Loader2, LogOut } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'

export function Header() {
  const { user, isAuthenticated, logout } = useAuth()
  const navigate = useNavigate()
  const { isMatching, isProcessing } = useJobMatchingStatus()

  const handleLogout = async () => {
    try {
      await logout()
      navigate('/login', { replace: true })
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-6 shrink-0">
          <Link to={isAuthenticated ? '/dashboard' : '/'} className="flex items-center space-x-2">
            <img src="/logo-black.png" alt="Pelgo" className="h-8" />
          </Link>
        </div>

        <div className="flex items-center gap-4">
          {isAuthenticated && (
            <>
              <span className="text-sm text-muted-foreground hidden sm:inline truncate max-w-[150px]">
                {user?.first_name || user?.full_name || user?.email || user?.phone_number}
              </span>
              {(isProcessing || isMatching) && (
                <div
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full animate-pulse ${
                    isProcessing
                      ? 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300'
                      : 'bg-purple-100 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300'
                  }`}
                >
                  <Loader2 className="h-3.5 w-3.5 animate-spin" />
                  <span className="text-xs font-semibold hidden sm:inline">
                    {isProcessing ? 'Processing...' : 'Matching...'}
                  </span>
                </div>
              )}
              <Button variant="ghost" size="icon" className="shrink-0" onClick={handleLogout}>
                <LogOut className="h-5 w-5" />
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  )
}
